(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const $ = (s, scope = root) => scope.querySelector(s);
    const $$ = (s, scope = root) => [...scope.querySelectorAll(s)];
    const grid = $('[data-grid]');
    if (!grid) return;
    const state = { compare: [], toastTimer: null };
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: root.dataset.currency || 'USD', maximumFractionDigits: 0
    });

    const cards = () => $$('[data-card]', grid);
    const returnStateKey = `uvi:return:${window.location.pathname}`;
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      try { sessionStorage.removeItem(returnStateKey); } catch (_) {}
    });
    const numberValue = (selector) => Number($(selector)?.value || 0);
    const checkedValues = (selector) => $$(selector).filter(i => i.checked).map(i => i.value);
    const escapeHTML = (value) => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
    const toast = (message) => {
      const el = $('[data-toast]');
      el.textContent = message;
      el.classList.add('is-visible');
      clearTimeout(state.toastTimer);
      state.toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2200);
    };

    const filters = () => ({
      query: ($('[data-search]')?.value || '').trim().toLowerCase(),
      models: checkedValues('[data-model]'),
      conditions: checkedValues('[data-condition]'),
      minPrice: numberValue('[data-price-min]') * 100,
      maxPrice: numberValue('[data-price-max]') * 100,
      minYear: numberValue('[data-year-min]'),
      maxLength: numberValue('[data-length-max]'),
      minSleeps: numberValue('[data-sleeps-min]')
    });

    const saveReturnState = (link) => {
      const f = filters();
      const card = link.closest('[data-card]');
      try {
        sessionStorage.setItem(returnStateKey, JSON.stringify({
          savedAt: Date.now(),
          inventoryUrl: window.location.href,
          scrollY: window.scrollY,
          cardId: card?.dataset.id || '',
          loadedCount: cards().length,
          sort: $('[data-sort]')?.value || 'featured',
          filters: f
        }));
      } catch (_) {}
    };

    const readReturnState = () => {
      try {
        const saved = JSON.parse(sessionStorage.getItem(returnStateKey) || 'null');
        if (!saved || Date.now() - Number(saved.savedAt) > 60 * 60 * 1000) return null;
        sessionStorage.removeItem(returnStateKey);
        return saved;
      } catch (_) {
        return null;
      }
    };

    const setReturnFilters = (saved) => {
      const f = saved?.filters || {};
      if ($('[data-search]')) $('[data-search]').value = f.query || '';
      if ($('[data-price-min]')) $('[data-price-min]').value = f.minPrice ? Number(f.minPrice) / 100 : '';
      if ($('[data-price-max]')) $('[data-price-max]').value = f.maxPrice ? Number(f.maxPrice) / 100 : '';
      if ($('[data-year-min]')) $('[data-year-min]').value = String(f.minYear || 0);
      if ($('[data-length-max]')) $('[data-length-max]').value = f.maxLength || '';
      if ($('[data-sleeps-min]')) $('[data-sleeps-min]').value = String(f.minSleeps || 0);
      $$('[data-model]').forEach(input => { input.checked = (f.models || []).includes(input.value); });
      $$('[data-condition]').forEach(input => { input.checked = (f.conditions || []).includes(input.value); });
      if ($('[data-sort]')) $('[data-sort]').value = saved.sort || 'featured';
    };

    const isMatch = (card, f) => {
      const d = card.dataset;
      if (f.query && !`${d.title} ${d.model}`.toLowerCase().includes(f.query)) return false;
      if (f.models.length && !f.models.includes(d.model)) return false;
      if (f.conditions.length && !f.conditions.includes(d.condition)) return false;
      if (f.minPrice && Number(d.price) < f.minPrice) return false;
      if (f.maxPrice && Number(d.price) > f.maxPrice) return false;
      if (f.minYear && Number(d.year) < f.minYear) return false;
      if (f.maxLength && Number(d.length) > f.maxLength) return false;
      if (f.minSleeps && Number(d.sleeps) < f.minSleeps) return false;
      return true;
    };

    const renderChips = (f) => {
      const area = $('[data-active-filters]');
      const chips = [];
      if (f.query) chips.push(['search', `Search: ${f.query}`]);
      f.models.forEach(v => chips.push([`model:${v}`, v.replaceAll('-', ' ')]));
      f.conditions.forEach(v => chips.push([`condition:${v}`, v.replaceAll('-', ' ')]));
      if (f.minPrice) chips.push(['price-min', `Min. ${money.format(f.minPrice / 100)}`]);
      if (f.maxPrice) chips.push(['price-max', `Max. ${money.format(f.maxPrice / 100)}`]);
      if (f.minYear) chips.push(['year-min', `${f.minYear} or newer`]);
      if (f.maxLength) chips.push(['length-max', `Up to ${f.maxLength} ft`]);
      if (f.minSleeps) chips.push(['sleeps-min', `Sleeps ${f.minSleeps}+`]);
      area.hidden = chips.length === 0;
      area.innerHTML = chips.map(([key, label]) => `<button class="uvi__chip" type="button" data-remove-filter="${escapeHTML(key)}">${escapeHTML(label)} <b>×</b></button>`).join('');
      const badge = $('[data-filter-badge]');
      badge.hidden = !chips.length;
      badge.textContent = chips.length;
    };

    const sortCards = () => {
      const mode = $('[data-sort]')?.value || 'featured';
      const list = cards();
      const getters = {
        'price-asc': c => Number(c.dataset.price),
        'price-desc': c => -Number(c.dataset.price),
        'year-desc': c => -Number(c.dataset.year),
        'length-asc': c => Number(c.dataset.length),
        'sleeps-desc': c => -Number(c.dataset.sleeps),
        featured: c => Number(c.dataset.index)
      };
      list.sort((a, b) => getters[mode](a) - getters[mode](b)).forEach(c => grid.appendChild(c));
    };

    const apply = () => {
      const f = filters();
      let visible = 0;
      cards().forEach((card, index) => {
        const match = isMatch(card, f);
        card.hidden = !match;
        if (match) card.style.setProperty('--uvi-order', Math.min(visible++, 12));
      });
      sortCards();
      $$('[data-result-count], [data-drawer-count], [data-visible-count]').forEach(el => el.textContent = visible);
      $('[data-empty]').hidden = visible !== 0;
      renderChips(f);
    };

    const reset = () => {
      $$('input[type="checkbox"][data-model], input[type="checkbox"][data-condition]').forEach(i => i.checked = false);
      $$('[data-search], [data-price-min], [data-price-max], [data-length-max]').forEach(i => i.value = '');
      if ($('[data-year-min]')) $('[data-year-min]').value = '0';
      if ($('[data-sleeps-min]')) $('[data-sleeps-min]').value = '0';
      apply();
    };

    const removeFilter = (key) => {
      if (key === 'search') $('[data-search]').value = '';
      if (key === 'price-min') $('[data-price-min]').value = '';
      if (key === 'price-max') $('[data-price-max]').value = '';
      if (key === 'year-min') $('[data-year-min]').value = '0';
      if (key === 'length-max') $('[data-length-max]').value = '';
      if (key === 'sleeps-min') $('[data-sleeps-min]').value = '0';
      if (key.startsWith('model:')) {
        const input = $$('[data-model]').find(i => i.value === key.split(':')[1]);
        if (input) input.checked = false;
      }
      if (key.startsWith('condition:')) {
        const input = $$('[data-condition]').find(i => i.value === key.split(':')[1]);
        if (input) input.checked = false;
      }
      apply();
    };

    const closeModal = () => {
      const modal = $('[data-modal]');
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    const saveFavorites = () => {
      const ids = cards().filter(c => $('[data-favorite]', c)?.getAttribute('aria-pressed') === 'true').map(c => c.dataset.id);
      localStorage.setItem('uvi-favorites', JSON.stringify(ids));
    };
    const restoreFavorites = () => {
      let ids = [];
      try { ids = JSON.parse(localStorage.getItem('uvi-favorites') || '[]'); } catch (_) {}
      cards().forEach(c => $('[data-favorite]', c)?.setAttribute('aria-pressed', ids.includes(c.dataset.id) ? 'true' : 'false'));
    };

    const renderCompare = () => {
      const tray = $('[data-compare-tray]');
      tray.hidden = state.compare.length === 0;
      $('[data-compare-count]').textContent = state.compare.length;
      $('[data-compare-items]').innerHTML = state.compare.map(c => `<span class="uvi-compare__item">${escapeHTML(c.dataset.title)}</span>`).join('');
    };
    const toggleCompare = (input) => {
      const card = input.closest('[data-card]');
      if (input.checked && state.compare.length >= 3) {
        input.checked = false;
        toast('You can compare up to 3 units');
        return;
      }
      state.compare = input.checked ? [...state.compare, card] : state.compare.filter(c => c !== card);
      renderCompare();
    };
    const clearCompare = () => {
      state.compare = [];
      $$('[data-compare]').forEach(i => i.checked = false);
      renderCompare();
    };
    const openCompare = () => {
      if (state.compare.length < 2) return toast('Select at least 2 units to compare');
      const rows = [
        ['Price', c => money.format(Number(c.dataset.price) / 100)],
        ['Year', c => Number(c.dataset.year) > 0 ? c.dataset.year : 'On request'],
        ['Length', c => Number(c.dataset.length) > 0 ? `${c.dataset.length} ft` : 'On request'],
        ['Sleeps', c => Number(c.dataset.sleeps) > 0 ? c.dataset.sleeps : 'On request'],
        ['Dry Weight', c => Number(c.dataset.weight) > 0 ? `${Number(c.dataset.weight).toLocaleString()} lb` : 'On request']
      ];
      const modal = $('[data-modal]');
      $('[data-modal-title]').textContent = 'Inventory Comparison';
      $('[data-modal-year]').textContent = `${state.compare.length} UNITS SELECTED`;
      $('[data-modal-image]').src = state.compare[0].querySelector('img')?.src || '';
      $('[data-modal-image]').alt = 'Inventory comparison';
      $('[data-modal-specs]').innerHTML = rows.map(([label, get]) => `<div><span>${label}</span><strong>${state.compare.map(get).join(' · ')}</strong></div>`).join('');
      $('[data-modal-price]').textContent = '';
      $('[data-modal-link]').href = state.compare[0].querySelector('a')?.href || '#';
      $('[data-modal-link]').textContent = 'View First Unit';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };

    const loadMore = async (button) => {
      const wrap = button.closest('[data-load-wrap]');
      const url = wrap.dataset.nextUrl;
      if (!url || button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      button.querySelector('span').textContent = 'Loading';
      try {
        const html = await fetch(url).then(r => { if (!r.ok) throw new Error(); return r.text(); });
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = doc.getElementById(root.id);
        const incoming = nextRoot?.querySelectorAll('[data-card]') || [];
        const start = cards().length;
        incoming.forEach((card, i) => { card.dataset.index = start + i; grid.appendChild(card); });
        const nextWrap = nextRoot?.querySelector('[data-load-wrap]');
        if (nextWrap?.dataset.nextUrl) wrap.dataset.nextUrl = nextWrap.dataset.nextUrl;
        else wrap.remove();
        restoreFavorites();
        apply();
        return true;
      } catch (_) {
        button.classList.remove('is-loading');
        button.querySelector('span').textContent = 'Try Again';
        toast('Unable to load more inventory. Please try again.');
        return false;
      }
    };

    const restoreReturnState = async () => {
      const saved = readReturnState();
      if (!saved) {
        apply();
        return;
      }
      setReturnFilters(saved);
      let attempts = 0;
      while (cards().length < Number(saved.loadedCount || 0) && attempts < 20) {
        const button = $('[data-load-more]');
        const previousCount = cards().length;
        attempts += 1;
        if (!button || !(await loadMore(button)) || cards().length <= previousCount) break;
      }
      apply();
      requestAnimationFrame(() => requestAnimationFrame(() => {
        const target = saved.cardId ? cards().find(card => card.dataset.id === saved.cardId) : null;
        if (target) target.scrollIntoView({ block: 'center' });
        else window.scrollTo(0, Number(saved.scrollY || 0));
      }));
    };

    root.addEventListener('input', e => {
      if (e.target.matches('[data-search], [data-price-min], [data-price-max], [data-length-max]')) apply();
      if (e.target.matches('[data-model], [data-condition], [data-year-min], [data-sleeps-min]')) apply();
      if (e.target.matches('[data-compare]')) toggleCompare(e.target);
    });
    root.addEventListener('change', e => {
      if (e.target.matches('[data-sort], [data-model], [data-condition], [data-year-min], [data-sleeps-min]')) apply();
    });
    root.addEventListener('click', e => {
      const detailLink = e.target.closest('[data-inventory-detail]');
      if (detailLink) {
        saveReturnState(detailLink);
        return;
      }
      const action = e.target.closest('button, [data-filter-close]');
      if (!action) return;
      if (action.matches('[data-filter-open]')) root.classList.add('is-filter-open');
      if (action.matches('[data-filter-close], [data-apply]')) root.classList.remove('is-filter-open');
      if (action.matches('[data-reset]')) reset();
      if (action.matches('[data-remove-filter]')) removeFilter(action.dataset.removeFilter);
      if (action.matches('[data-modal-close]')) closeModal();
      if (action.matches('[data-favorite]')) {
        const active = action.getAttribute('aria-pressed') === 'true';
        action.setAttribute('aria-pressed', String(!active)); saveFavorites(); toast(active ? 'Removed from saved units' : 'Saved to this browser');
      }
      if (action.matches('[data-compare-clear]')) clearCompare();
      if (action.matches('[data-compare-open]')) openCompare();
      if (action.matches('[data-load-more]')) loadMore(action);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeModal(); root.classList.remove('is-filter-open'); } });

    restoreFavorites();
    restoreReturnState();
  };

  const boot = () => document.querySelectorAll('.uvi').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('.uvi')));
})();
